import React, {useEffect, useRef, useState, useCallback} from "react";
import { useParams, useNavigate } from 'react-router-dom';
import PortalSelector from "../../components/PortalSelector";
import {BestandViewHeaders, BestandViewHeadersDGG} from "../../staticData/bestandViewHeaders";
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {useStateValue} from "../../states/StateProvider";
import {useReactToPrint} from "react-to-print"
import BestandListDataSection from "./partial/bestandListDataSection";
import {BestandView2Headers} from "../../staticData/bestandView2Headers";
import {AES, enc} from "crypto-js";
import {BestandView3Headers, BestandView3HeadersDgg} from "../../staticData/bestandView3Headers";
import {BestandView4Headers, BestandView4HeadersDgg} from "../../staticData/bestandView4Headers";
import {BestandView5Headers, BestandView5HeadersDgg} from "../../staticData/bestandView5Headers";

const BestantList = () => {
    try {
        let user = localStorage.user
    } catch (e) {
        window.location.replace('/anmeldung')
    }
    const [printing, setPrinting] = useState(false)
    const [loading, setLoading] = useState(true);
    const [hasFilter, setHasFilter] = useState(false);
    const [loadingViews, setLoadingViews] = useState(false);
    const [rows, setRows] = useState('10');
    const [url, setUrl] = useState('getBestands');
    const [viewName, setViewName] = useState('Firmenprojekte');
    const [superAdmin, setSuperAdmin] = useState('')
    const [views, setViews] = useState([]);
    let PageSize = rows;
    const [{pageBestand, sortColumn, sortMethod, filterID, filter, dateFilter, secretKey, portal}, dispatch] = useStateValue();
    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState(0);
    const componentRef = useRef();
    const requestInProgress = useRef(false);
    const currentRequest = useRef(null);
    const initializationComplete = useRef(false);
    const milestoneProcessing = useRef(false);
    const milestoneApplied = useRef(false);

    // Pending filter state - filters are stored here until user triggers search
    const [pendingFilter, setPendingFilter] = useState({a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 1, i: null, j: null, k: 1, l: null, m: null});
    const [pendingFilterID, setPendingFilterID] = useState({a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 111, i: null, j: null, k: 114, l: 115, m: null});
    const [hasPendingChanges, setHasPendingChanges] = useState(false);

    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const userID = user.ID
    const role = user.role === 'Internal' ? 'i' : user.role === 'ExtRUV' ? 'er' : user.role === 'ExtDGG' ? 'ed' : user.role === 'ManRUV' ? 'mr' : user.role === 'ManDGG' ? 'md' : 'c'
    const { mileStoneNumber } = useParams();
    const navigate = useNavigate();
    const [milestoneList, setMilestoneList] = useState([]);
    const [isInitializing, setIsInitializing] = useState(true);

    // Consolidated fetch function with proper request coordination
    const fetchData = useCallback(async (customParams = {}) => {
        if (requestInProgress.current) {
            if (currentRequest.current) {
                // Cancel the previous request
                currentRequest.current.cancel && currentRequest.current.cancel();
            }
        }

        requestInProgress.current = true;
        setLoading(true);

        try {
            // Determine URL based on viewName
            let apiUrl = 'getBestands';
            if (viewName === 'Projekt-Tafel') {
                apiUrl = 'getBestands2';
            } else if (viewName === 'Auswertung Vertrieb') {
                apiUrl = 'getBestands3';
            } else if (viewName === 'Auswertung DGAPI') {
                apiUrl = 'getBestands4';
            } else if (viewName === 'Auswertung Beratung') {
                apiUrl = 'getBestands5';
            }

            const formData = new FormData();
            formData.append('portal', portal);
            formData.append('userID', userID);
            formData.append('rows', customParams.rows || rows);
            formData.append('page', customParams.page || pageBestand);
            formData.append('sortColumn', customParams.sortColumn || sortColumn);
            formData.append('sortMethod', customParams.sortMethod || sortMethod);
            formData.append('filterID', JSON.stringify(customParams.filterID || filterID));
            formData.append('filter', JSON.stringify(customParams.filter || filter));
            formData.append('dateFilter', JSON.stringify(customParams.dateFilter || dateFilter));

            const requestPromise = Api().post(apiUrl, formData);
            currentRequest.current = requestPromise;

            const res = await requestPromise;
            
            setUsers(res.data.bestands);
            setTotal(Number(res.data?.bestands[0]?.totalCustomers));
            
            if (printing && res.data.bestands?.length > 0 && (customParams.rows || rows) === '10000') {
                setTimeout(() => handlePrint(), 1);
                setTimeout(() => setPrinting(false), 1);
                setRows('10');
            }

        } catch (error) {
            if (error.name !== 'CanceledError') {
                console.error('Error fetching data:', error);
                toast.error('Etwas ist schief gelaufen!!');
            }
        } finally {
            setLoading(false);
            requestInProgress.current = false;
            currentRequest.current = null;
        }
    }, [portal, userID, rows, pageBestand, sortColumn, sortMethod, filterID, filter, dateFilter, viewName, printing]);

    // Initialize portal and complete setup
    useEffect(() => {
        const initializeComponent = async () => {
            setSuperAdmin(user.isSAdmin);
            
            // Set portal based on user role
            if ((user.role === 'ExtDGG' || user.role === 'ManDGG')) {
                dispatch({type:'SET_PORTAL', item:'dgg'});
                localStorage.setItem('portal', 'dgg');
            } else if ((user.role === 'ExtRUV' || user.role === 'ManRUV')) {
                dispatch({type:'SET_PORTAL', item:'ruv'});
                localStorage.setItem('portal', 'ruv');
            } else {
                if(localStorage.getItem('portal') !== ''){
                    dispatch({type:'SET_PORTAL', item:localStorage.getItem('portal')});
                }else{
                    dispatch({type:'SET_PORTAL', item:'dgg'});
                    localStorage.setItem('portal', 'dgg');
                }
            }
            
            // Wait for portal to be set, then load milestone data and handle initial data fetch
            setTimeout(() => {
                setIsInitializing(false);
            }, 100);
        };
        
        initializeComponent();
    }, []);


    // Load views when portal is available
    useEffect(() => {
        if (portal && !isInitializing) {
            setLoadingViews(true);
            Api().get(`/getRoleViews/${portal}/${role}`).then(res => {
                setViews(Object.values(res.data.views));
                setLoadingViews(false);
            }).catch(e => {
                setLoadingViews(false);
            });
        }
    }, [portal, role, isInitializing]);

    // Reset page when view, filter, or dateFilter changes
    useEffect(() => {
        if (!isInitializing) {
            dispatch({type: "SET_PAGE_BESTAND", item: 1});
        }
    }, [viewName, filter, dateFilter, isInitializing]);

    // Load milestone data and handle milestone-based filtering
    useEffect(() => {
        if (portal && !isInitializing) {
            // Load milestone data first
            Api().get(`/sp_getMilestoneData/${portal}`).then(res => {
                setMilestoneList(res.data);
                
                // Handle milestone-based URL parameter if present
                if (mileStoneNumber && Number.isInteger(Number(mileStoneNumber))) {
                    milestoneApplied.current = true;
                    handleMilestoneFiltering(res.data, mileStoneNumber);
                } else {
                    // Regular data fetch without milestone filtering
                    initializationComplete.current = true;
                    fetchData();
                }
            }).catch(e => {
                console.error('Error fetching milestone data:', e);
                toast.error('Etwas ist schief gelaufen!!');
                initializationComplete.current = true;
                milestoneProcessing.current = false;
                fetchData();
            });
        }
    }, [portal, isInitializing, mileStoneNumber]);

    // Handle milestone-specific filtering
    const handleMilestoneFiltering = useCallback((milestoneData, milestoneNumber) => {
        // Set processing flag immediately
        milestoneProcessing.current = true;
        
        // Find milestone by milestoneID and get milestoneLabel
        const milestone = milestoneData.find(m => m.milestoneID === milestoneNumber);
        if (!milestone) {
            console.error(`Milestone with ID ${milestoneNumber} not found in milestone list`);
            initializationComplete.current = true;
            milestoneProcessing.current = false;
            fetchData();
            return;
        }

        const milestoneLabel = milestone.milestoneLabel || '';
        const milestonePartialName = milestoneLabel.substring(0, 5);

        let milestoneFilterID = {};
        let milestoneFilter = {};

        if (portal === 'dgg') {
            milestoneFilterID = {
                a: null, b: null, c: null, d: null, e: 5, f: null, g: null,
                h: 111, i: null, j: null, k: 114
            };

            milestoneFilter = {
                a: null, b: null, c: null, d: null, 
                e: milestonePartialName, f: null, g: null,
                i: (Number(milestoneNumber) === 13 ? 1 : null), j: null, h: 1, k: 1
            };

            if (Number(milestoneNumber) === 13) {
                milestoneFilterID.i = 112;
            }
        } else {
            milestoneFilterID = {
                a: null, b: null, c: null, d: null, e: null, f: null, g: 7,
                h: 111, i: null, j: null, k: 114
            };

            milestoneFilter = {
                a: null, b: null, c: null, d: null, e: null, f: null,
                g: milestonePartialName, i: (Number(milestoneNumber) === 18 ? 1 : null),
                j: null, h: 1, k: 1
            };

            if (Number(milestoneNumber) === 18) {
                milestoneFilterID.i = 112;
            }
        }

        // Update global state and fetch with milestone filters
        dispatch({type: "SET_SORTBESTANDFILTERID", item: milestoneFilterID});
        dispatch({type: "SET_SORTBESTANDFILTER", item: milestoneFilter});

        const milestoneDateFilter = {id: null, value: null};
        
        // Update other state values for milestone filtering
        dispatch({type: "SET_DATEFILTER", item: milestoneDateFilter});
        dispatch({type: "SET_PAGE_BESTAND", item: 1});
        dispatch({type: "SET_SORTBESTANDCOLUMN", item: 7});
        dispatch({type: "SET_SORTBESTANDMETHOD", item: 'asc'});
        
        // Navigate and complete initialization
        navigate('/firmenprojekte-liste', { replace: true });
        initializationComplete.current = true;
        
        // Allow main useEffect to handle the fetch after state updates
        setTimeout(() => {
            milestoneProcessing.current = false;
        }, 100);
        
        console.log(`Filtering by milestone ID: ${milestoneNumber}, Label: "${milestoneLabel}", Partial: "${milestonePartialName}"`);
    }, [portal, fetchData, navigate, dispatch]);

    // Main data fetching - only after initialization is complete and not during milestone processing
    useEffect(() => {
        if (portal && initializationComplete.current && !isInitializing && !milestoneProcessing.current) {
            // Set URL based on viewName (kept for backward compatibility)
            if (viewName === 'Firmenprojekte') {
                setUrl('getBestands');
            } else if (viewName === 'Projekt-Tafel') {
                setUrl('getBestands2');
            } else if (viewName === 'Auswertung Vertrieb') {
                setUrl('getBestands3');
            } else if (viewName === 'Auswertung DGAPI') {
                setUrl('getBestands4');
            } else if (viewName === 'Auswertung Beratung') {
                setUrl('getBestands5');
            }

            // Removed automatic delay-based filter triggering
            // Filters are now only applied when user clicks "Filter starten" button or presses Enter
            fetchData();
        }
    }, [rows, userID, pageBestand, sortColumn, sortMethod, viewName, portal, fetchData, isInitializing]);

    // Function to apply pending filters - called when user clicks "Filter starten" or presses Enter
    const applyFilters = useCallback(() => {
        dispatch({type: "SET_SORTBESTANDFILTER", item: pendingFilter});
        dispatch({type: "SET_SORTBESTANDFILTERID", item: pendingFilterID});
        dispatch({type: "SET_PAGE_BESTAND", item: 1});
        setHasPendingChanges(false);
        // Trigger data fetch with new filters
        fetchData({filter: pendingFilter, filterID: pendingFilterID, page: 1});
    }, [pendingFilter, pendingFilterID, dispatch, fetchData]);

    // Sync pending filter with global filter on initial load and after clearFilters
    useEffect(() => {
        setPendingFilter(filter);
        setPendingFilterID(filterID);
    }, []);

    // Handle view-specific configuration changes
    useEffect(() => {
        if (!isInitializing && initializationComplete.current) {
            clearFilters();
            
            if (viewName === 'Auswertung Vertrieb') {
                dispatch({type: "SET_DATEFILTER", item: {id: 14, value: true}});
                dispatch({type: "SET_SORTBESTANDCOLUMN", item: 14});
                dispatch({type: "SET_SORTBESTANDMETHOD", item: 'desc'});
            } else if (viewName === 'Auswertung DGAPI') {
                dispatch({type: "SET_DATEFILTER", item: {id: 14, value: true}});
                dispatch({type: "SET_SORTBESTANDCOLUMN", item: 14});
                dispatch({type: "SET_SORTBESTANDMETHOD", item: 'desc'});
            } else if (viewName === 'Auswertung Beratung') {
                dispatch({type: "SET_DATEFILTER", item: {id: 11, value: true}});
                dispatch({type: "SET_SORTBESTANDCOLUMN", item: 11});
                dispatch({type: "SET_SORTBESTANDMETHOD", item: 'desc'});
            } else {
                dispatch({type: "SET_SORTBESTANDCOLUMN", item: 7});
                dispatch({type: "SET_SORTBESTANDMETHOD", item: 'asc'});
            }
        }
    }, [viewName, isInitializing]);

    useEffect(() => {
        // Check if there are any user-applied filters (exclude system defaults h=1, k=1, and system checkboxes i,j,l which default to 0)
        const userFilterKeys = ['a', 'b', 'c', 'd', 'e', 'f', 'g']; // Only search fields and P-Status fields
        const hasUserFilters = userFilterKeys.some(key => {
            const value = filter[key];
            return value !== null && value !== undefined && value !== '';
        });
        
        // Check if checkboxes i,j,l are enabled (user applied these filters)
        const hasCheckboxFilters = filter.i === 1 || filter.j === 1 || filter.l === 1;
        
        // Reset button should be enabled (hasFilter=true) when there are user filters or checkbox filters
        if (hasUserFilters || hasCheckboxFilters) {
            setHasFilter(true);  // Enable reset button
        } else {
            setHasFilter(false); // Disable reset button (no user filters active)
        }
    }, [filter]);

    useEffect(() => {
        const closeDropdown = (event) => {
            if (!dropdownRef.current?.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', closeDropdown);
        return () => {
            document.removeEventListener('click', closeDropdown);
        };
    }, []);

    function clearFilters() {
        const defaultFilter = {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 1, i: null, j: null, k:1, l:null, m: null};
        const defaultFilterID = {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 111, i: null, j: null, k:114, l:115, m: null};

        dispatch({
            type: "SET_SORTBESTANDFILTER",
            item: defaultFilter
        })
        dispatch({
            type: "SET_SORTBESTANDFILTERID",
            item: defaultFilterID
        })
        // Also reset pending filters
        setPendingFilter(defaultFilter);
        setPendingFilterID(defaultFilterID);
        setHasPendingChanges(false);
        // dispatch({
        //     type: "SET_DATEFILTER",
        //     item: {id: null, value: null}
        // })
    }

    function setPageStates(e) {
        dispatch({type: "SET_PAGE_BESTAND", item: 1})
        setRows(e.target.value)
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    async function setPrintState() {
        setPrinting(true)
        setRows('10000')
    }

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    function portalSelect(e) {
        clearFilters()
        dispatch({type:'SET_PORTAL', item:e.target.value})
        localStorage.setItem('portal', e.target.value)
    }

    function onPortalChanged(){
        if(portal==='dgg'){
            setViewName('Firmenprojekte')
        }
    }

    return (
        <div className={`dashboardContainer`}>
            <div className='flex justify-start items-center content-center pb-5'>
                <h2 className='text-2xl lg:text-left'>Firmenprojekt-Liste</h2>
                {
                    <PortalSelector
                        portal={portal}
                        setPortal={(value) => {
                            clearFilters();
                            dispatch({type: 'SET_PORTAL', item: value});
                            localStorage.setItem('portal', value);
                        }}
                        superAdmin={superAdmin}
                        role={role}
                        disabled={loading}
                    />
                }
            </div>
            <div className='bg-white'>
                <BestandListDataSection
                    views={views}
                    rows={rows}
                    setPrintStte={setPrintState}
                    hasFilter={hasFilter}
                    clearFilters={clearFilters}
                    setViewName={setViewName}
                    dropdownRef={dropdownRef}
                    toggleDropdown={toggleDropdown}
                    isOpen={isOpen}
                    user={user}
                    url={url}
                    loadingViews={loadingViews}
                    users={users}
                    loading={loading}
                    printPDFRef={componentRef}
                    headers={(viewName === 'Firmenprojekte' && portal === 'ruv') ? BestandViewHeaders : (viewName === 'Firmenprojekte' && portal === 'dgg') ? BestandViewHeadersDGG : viewName === 'Projekt-Tafel' ? BestandView2Headers : viewName === 'Auswertung Vertrieb' ? (portal==='ruv'?BestandView3Headers:BestandView3HeadersDgg) : viewName === 'Auswertung DGAPI' ? (portal==='ruv'?BestandView4Headers:BestandView4HeadersDgg) : (portal==='ruv'?BestandView5Headers : BestandView5HeadersDgg)}
                    count={viewName === (viewName === 'Firmenprojekte' && portal === 'ruv') ? BestandViewHeaders.length : (viewName === 'Firmenprojekte' && portal === 'dgg') ? BestandViewHeadersDGG.length : viewName === 'Projekt-Tafel' ? BestandView2Headers.length : viewName === 'Auswertung Vertrieb' ? BestandView3Headers.length : viewName === 'Auswertung DGAPI' ? BestandView4Headers.length : BestandView5Headers.length}
                    printing={printing}
                    sortColumn={sortColumn}
                    sortMethod={sortMethod}
                    total={total}
                    PageSize={PageSize}
                    filterID={filterID}
                    filter={filter}
                    view={viewName}
                    portalChanged={onPortalChanged}
                    portal={portal}
                    mileStoneNumber={mileStoneNumber}
                    pendingFilter={pendingFilter}
                    setPendingFilter={setPendingFilter}
                    pendingFilterID={pendingFilterID}
                    setPendingFilterID={setPendingFilterID}
                    applyFilters={applyFilters}
                    hasPendingChanges={hasPendingChanges}
                    setHasPendingChanges={setHasPendingChanges}
                />
                <div
                    className={`${loading ? 'hideDiv' : ''} absolute 'right-0'  ${viewName === 'Firmenprojekte' ? '-mt-16' : '-mt-18'} -mt-14 pb-9 mx-10`}>
                    <div className='flex justify-center'>
                        <p className={`${(users?.length === 0) && 'hideDiv'} mr-2 text-sm text-grey mt-2`}>
                            {pageBestand === 1 ? pageBestand : (1 + (Number(rows) * pageBestand)) - Number(rows)} bis {(users?.length < Number(rows)) ? users.length + Number(rows) < total ? users.length + (Number(rows) * pageBestand) - Number(rows) : total : (Number(rows) + (Number(rows) * pageBestand)) - Number(rows)} von {total} Einträge
                        </p>
                        <h2 className={`${(users?.length === 0) && 'hideDiv'}  text-sm text-grey mt-2 ml-10`}>
                            Einträge anzeigen:
                            <span>
                                <select onChange={setPageStates} className={` bg-transparent text-mainBlue`}>
                                    <option value={'10'}>{10}</option>
                                    <option value={'25'}>{25}</option>
                                    <option value={'10000'}>Alle</option>
                                </select>
                            </span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BestantList
